import { render, staticRenderFns } from "./newLaborer.vue?vue&type=template&id=7d0ea5a6&scoped=true"
import script from "./newLaborer.vue?vue&type=script&lang=js"
export * from "./newLaborer.vue?vue&type=script&lang=js"
import style0 from "./newLaborer.vue?vue&type=style&index=0&id=7d0ea5a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d0ea5a6",
  null
  
)

export default component.exports